export default __webpack_public_path__ + "static/media/bernay7.65c324aa.jpg";